module.exports = __webpack_public_path__ + "static/media/clap.80bc0a43.svg";